import { Flex, Space, Tabs } from "antd";
import { TopBreadcrumb } from "./TopBreadcrumb";

export const ShowWrapper = ({ actions, details, children }) => {
  return (
    <div>
      <Flex justify="space-between" align="center" wrap={false}>
        <TopBreadcrumb />
        <div>
          { actions }
        </div>
      </Flex>
      { details && (
        <Tabs
          items={details}
        />
      ) }
      {children}
    </div>
  );
}